import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { URL, COMPANY_NAME_EN, OUTER_URL } from '../../utils/Utils'
import './Header.scss'

/**
 * @file Header 영역
 */
function Header() {
    const [themeColor, setThemeColor] = useState('white') //theme color: black/white
    const [isMenuOpen, setIsMenuOpen] = useState(false) //모바일 화면에서 menu 아이콘 선택시, 메뉴 보이는 여부 true/false
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        let url = location.pathname

        if (url === URL.HOME.MAIN || url === URL.SCOOTER.S2 || url === URL.SCOOTER.EV_C1) {
            setThemeColor('black')
        } else {
            setThemeColor('white')
        }
    }, [location])

    return (
        <nav data-color={themeColor}>
            <div id="nav-wrap">
                <div id="home">
                    <div className="mobile-only burger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <img className={'menu-icon-' + themeColor} alt="menu icon" />
                    </div>
                    <a href={URL.HOME.MAIN}>
                        <img className={'logo-icon-' + themeColor} alt={`${COMPANY_NAME_EN} logo`} />
                    </a>
                    <div className="mobile-only"></div>
                </div>
                <div id="menu" className={isMenuOpen ? 'active' : ''} style={{ backgroundColor: themeColor }}>
                    <a href={URL.COMPANY.MAIN}>회사소개</a>
                    <a href={URL.SCOOTER.MAIN}>스마트 스쿠터</a>
                    <a href={URL.NETWORK.MAIN}>스왑 네트워크</a>
                    <a href={URL.RATE_PLAN.MAIN}>요금제</a>
                    {/* <a href={URL.NEWS.MAIN}>최신소식</a> */}
                    <a href={URL.CUSTOMER.CUSTOMER_CENTER}>고객지원</a>

                    {/* 사전구매예약 */}
                    <button className="pc-header-subsidy-btn" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        고고로몰
                    </button>
                    <a
                        className="mobile-header-subsidy-btn"
                        href=""
                        onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        고고로몰
                    </a>
                </div>
            </div>
        </nav>
    )
}

export default Header
